// cSpell:enableCompoundWords
import { createJoinResumeGameAction, loadGameByIdLoader } from 'api/GameAPI';
import { appLoader } from 'api/UserAPI';
import App from 'app/App';
import ErrorBoundary from 'components/errorboundary/ErrorBoundary';
import FootballField from 'components/footballfield/FootballField';
import SqLoader from 'components/loader/SqLoader';
import CompletedGamesSection from 'components/tabs/gameselect/sections/CompletedGamesSection';
import CreateGameSection from 'components/tabs/gameselect/sections/CreateGameSection';
import GamesSection from 'components/tabs/gameselect/sections/GamesSectionInfoPanel';
import JoinGamesSection from 'components/tabs/gameselect/sections/JoinGamesSection';
import ResumeGamesSection from 'components/tabs/gameselect/sections/ResumeGamesSection';
import { SqRoutes } from 'constants/Routes';
import { RequireAuth } from 'hooks/useAuth';
import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

// #region LAZY LOADING *******************************************************

// const AnonymousBox = React.lazy(() =>
//   import('components/tabs/login/AnonymousBox').then((module) => ({ default: module.AnonymousBox }))
// );

const ForgotPasswordBox = React.lazy(() =>
  import('components/tabs/login/ForgotPasswordBox').then((module) => ({ default: module.ForgotPasswordBox }))
);

const GameTab = React.lazy(() =>
  import('components/tabs/gameon/GameTab').then((module) => ({ default: module.GameTab }))
);

const GameSelectTab = React.lazy(() =>
  import('components/tabs/gameselect/GameSelectTab').then((module) => ({ default: module.GameSelectTab }))
);

const LoginBox = React.lazy(() =>
  import('components/tabs/login/LoginBox').then((module) => ({ default: module.LoginBox }))
);

const LoginTab = React.lazy(() =>
  import('components/tabs/login/LoginTab').then((module) => ({ default: module.LoginTab }))
);

const RegisterBox = React.lazy(() =>
  import('components/tabs/login/RegisterBox').then((module) => ({ default: module.RegisterBox }))
);
// #endregion

const router = createBrowserRouter(
  [
    {
      id: 'route_app',
      element: <App />,
      path: SqRoutes.Home,
      errorElement: <ErrorBoundary debug={'From route_app'} />,
      loader: appLoader,
      hydrateFallbackElement: <SqLoader />,
      children: [
        {
          id: 'route_app_index',
          index: true,
          element: <FootballField />,
        },
        {
          id: 'route_auth',
          element: <LoginTab />,
          children: [
            { id: 'route_auth_register', path: SqRoutes.Register, element: <RegisterBox /> },
            { id: 'route_auth_login', path: SqRoutes.Login, element: <LoginBox /> },
            // { id: 'route_auth_anonymous', path: SqRoutes.Anonymous, element: <AnonymousBox /> },
            { id: 'route_auth_forgotpassword', path: SqRoutes.ForgotPassword, element: <ForgotPasswordBox /> },
          ],
        },

        {
          id: 'route_lobby',
          path: SqRoutes.Lobby,
          element: (
            <RequireAuth>
              <GameSelectTab />
            </RequireAuth>
          ),
          children: [
            { id: 'route_lobby_index', index: true, element: <GamesSection /> },
            { id: 'route_lobby_join', path: SqRoutes.Join, element: <JoinGamesSection /> },
            { id: 'route_lobby_resume', path: SqRoutes.Resume, element: <ResumeGamesSection /> },
            { id: 'route_lobby_creategame', path: SqRoutes.CreateGame, element: <CreateGameSection /> },
            { id: 'route_lobby_completed', path: SqRoutes.Completed, element: <CompletedGamesSection /> },
          ],
          hydrateFallbackElement: <SqLoader />,
          errorElement: <ErrorBoundary debug={'From route_lobby'} />,
          action: createJoinResumeGameAction,
        },
        {
          id: 'route_game',
          path: SqRoutes.Game,
          element: (
            <RequireAuth>
              <GameTab />
            </RequireAuth>
          ),
          hydrateFallbackElement: <SqLoader />,
          loader: loadGameByIdLoader,
        },
      ],
    },
  ],
  {
    basename: '/',
    future: { v7_startTransition: true },
  }
);

export default router;
